import { Backdrop, CircularProgress } from "@mui/material";
import { LoadingInfo } from "./Loadable";

interface LoadingFullScreenProps {
  loadingInfo?: LoadingInfo;
}

/** Component that disables the screen while data is loading */
const LoadingFullScreen = ({ loadingInfo }: LoadingFullScreenProps) => {
  const open = loadingInfo ? loadingInfo.state === "loading" : true;

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingFullScreen;
